module.exports = __webpack_public_path__ + "img/question2x.png?759b39b31acddf7d994e0408ddf41749";